import { validArchiveUploadExtensions, validSBOMUploadExtensions } from '../../../utils';
import type { FileType } from '../../../../shared/fileUpload';

/**
 * Get the valid file extensions for the given fileType
 */
export const getValidFileExtensions = (fileType: FileType) =>
  fileType === 'archive' ? validArchiveUploadExtensions : validSBOMUploadExtensions;
